import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'apc-persona-exists-info',
  templateUrl: './persona-exists-info.component.html',
  styleUrls: ['./persona-exists-info.component.scss', '../create-persona.component.scss']
})
export class PersonaExistsInfoComponent {
  @Input() public personas = [];
  @Input() public currentPersona;
 constructor(
    public activeModal: NgbActiveModal
) { }


close() {
    this.activeModal.close(false);
}

onDismiss() {
    this.activeModal.dismiss(false);
}

confirm() {
  this.activeModal.close(true);
}

onResult() {
    // do something with you data and send result
    this.activeModal.close("ok");
}
}
